import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import VueCookies from 'vue-cookies'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// baseURL 环境自适应
// - 生产域名 ymzx.net 走 nginx 反代的 /service 子路径
// - 其他环境（本地开发、内网测试）走当前 host 的 :2334 端口
const PROD_HOSTS = ['ymzx.net', 'www.ymzx.net']
function getApiBase () {
  const hostname = window.location.hostname
  return PROD_HOSTS.includes(hostname)
    ? 'https://ymzx.net/service'
    : `${window.location.protocol}//${hostname}:2334`
}
const apiBase = getApiBase()

// 创建axios实例
const service = axios.create({
  baseURL: apiBase,
  // 超时
  timeout: 200000
})

// request拦截器
service.interceptors.request.use(config => {
	let token = VueCookies.get('userToken');
	// 是否需要设置 token
	if (token) {
		config.headers['authorization'] = token // 让每个请求携带自定义token 请根据实际情况自行修改
	}
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof(value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            url += subPart + encodeURIComponent(value[key]) + "&";
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    // const msg = errorCode[code] || res.data.msg || errorCode['default']
    if (code === -1) {
      location.href = '/login';
    }else {
      return res.data
    }
  },
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export { apiBase }
export default service
